export function isValidAverageHours(value: string): boolean {
  // allow empty string (field can be blank)
  if (value === '') return true;

  // only allow integers 0-99 (no negative, no decimals, max 2 digits)
  return /^[0-9]{1,2}$/.test(value);
}

export function isValidGpa(value: string): boolean {
  // allow empty string (field can be blank)
  if (value === '') return true;

  // allow numeric input with at most one decimal point and max length of 6 characters
  return value.length <= 6 && /^(?!\.$)\d*\.?\d*$/.test(value);
}

export function isValidAmountRequested(value: string): boolean {
  // allow empty string (field can be blank)
  if (value === '') return true;

  // allow non-negative numeric input with at most one decimal point
  return /^(?!\.$)\d*\.?\d*$/.test(value);
}
